import EditName from './edit_amount'
import { reduxForm } from 'redux-form'
import { updateRemotely } from 'redux/modules/campaign'
import { getCampaignSelector } from 'redux/selectors/campaign'
import { combine, required, atMost } from 'lib/validators'
import { getI18n } from 'client/i18n'
import { formatMoney } from 'client/griffin'
import {
  POOLS_CAMPAIGN_TYPES,
  CROWDFUNDING_GOAL_AMOUNT,
} from 'shared/shared_consts'

const { CROWD_FUNDING } = POOLS_CAMPAIGN_TYPES
const i18n = getI18n('components/edit_glimpse/edit_amount')
const { MAX_AMOUNT } = CROWDFUNDING_GOAL_AMOUNT

const mapStateToProps = (state, props) => {
  const campaign = getCampaignSelector(state, props)
  const campaignType = campaign.campaign_type
  const maxGoalAmount = (campaign.moneybox_amount = MAX_AMOUNT)
  const formattedMaxGoalAmount = formatMoney(campaign.currency, maxGoalAmount)

  let validators = [required('goal', i18n('goal_amount_required'))]
  if (campaignType === CROWD_FUNDING) {
    validators.push(
      atMost(
        'goal',
        maxGoalAmount,
        i18n('goal_amount_invalid', {
          amount: formattedMaxGoalAmount,
        })
      )
    )
  }

  return {
    validate: combine(...validators),
    initialValues: {
      goal: campaign.goal,
    },
    currencyCode: campaign.currency,
    campaignType,
    formattedMaxGoalAmount,
  }
}

const mapDispatchToProps = (dispatch, { campaignId }) => {
  return {
    onSave(formValues) {
      return dispatch(
        updateRemotely(campaignId, { goal: formValues.goal || 0 })
      )
    },
  }
}

export default reduxForm(
  {
    form: 'edit_amount',
    fields: ['goal'],
  },
  mapStateToProps,
  mapDispatchToProps
)(EditName)
